import api from '../api';

const getAuthHeaders = (token) => ({
  Authorization: `Bearer ${token}`
});

// Resource API functions
export const resourceApi = {
  // Lấy danh sách resources
  getResources: async (token, params = {}) => {
    try {
      const response = await api.get('/resources', {
        headers: getAuthHeaders(token),
        params
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error getting resources:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Lấy thông tin resource theo ID
  getResourceById: async (token, resourceId) => {
    try {
      const response = await api.get(`/resources/${resourceId}`, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting resource by ID:', error);
      throw error;
    }
  },

  // Tạo resource mới
  createResource: async (token, resourceData) => {
    try {
      const response = await api.post('/resources', resourceData, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error creating resource:', error);
      throw error;
    }
  },

  // Cập nhật resource
  updateResource: async (token, resourceId, resourceData) => {
    try {
      const response = await api.put(`/resources/${resourceId}`, resourceData, {
        headers: getAuthHeaders(token)
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error updating resource:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Xóa resource
  deleteResource: async (token, resourceId) => {
    try {
      const response = await api.delete(`/resources/${resourceId}`, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting resource:', error);
      throw error;
    }
  },

  // Lấy thống kê resources
  getResourceStatistics: async (token, params = {}) => {
    try {
      const response = await api.get('/resources/statistics', {
        headers: getAuthHeaders(token),
        params
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error getting resource statistics:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Lấy thống kê theo loại resource
  getResourceTypeStatistics: async (token, resourceType = 'all') => {
    try {
      const response = await api.get(`/resources/statistics/${resourceType}`, {
        headers: getAuthHeaders(token)
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error getting resource type statistics:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  }
};
